import React from 'react';
import { Badge, Col, Row, Tab, Tabs as BTabs } from 'react-bootstrap';

const Tabs = () => (
  <Row className="styles-section" id="tabs">
    <Col xs={12}>
      <h3>Tabs</h3>
    </Col>
    <Col className="mb-5" xs={12}>
      <BTabs bg="light" expand="xs">
        <Tab eventKey="home" title="Home">
          <div>Home</div>
        </Tab>
        <Tab eventKey="profile" title="Profile">
          <div>Profile</div>
        </Tab>
        <Tab eventKey="contact" title="Contact" disabled>
          <div>Contact</div>
        </Tab>
        <Tab eventKey="tab1" title="Tab 1" >
          <div>Tab 1</div>
        </Tab>
        <Tab eventKey="tab2" title="Tab 2" >
          <div>Tab 2</div>
        </Tab>

      </BTabs>
    </Col>

    <Col xs={12}>
      <BTabs bg="light" expand="xs">
        <Tab eventKey="tab1" title={
          <React.Fragment>
            tab 1
            <Badge variant="dark">707</Badge>
          </React.Fragment>
        }>
          <div>tab1</div>
        </Tab>
        <Tab eventKey="tab2" title={
          <React.Fragment>
            tab 2
            <Badge variant="dark">707</Badge>
          </React.Fragment>
        }>
          <div>tab2</div>
        </Tab>
        <Tab eventKey="tab3" title={
          <React.Fragment>
            tab 3
            <Badge variant="dark">707</Badge>
          </React.Fragment>
        }>
          <div>tab3</div>
        </Tab>
        <Tab eventKey="tab4" disabled title={
          <React.Fragment>
            tab 4
            <Badge variant="dark">707</Badge>
          </React.Fragment>
        } >
          <div>tab4</div>
        </Tab>
        <Tab eventKey="tab5" title="tab5" >
          <div>tab5</div>
        </Tab>

      </BTabs>
    </Col >
  </Row >
);

export default Tabs;